interface JsonModule {
  default: Record<string, unknown>;
}

export type LocaleModule = Record<string, JsonModule>;

function createTranslations(modules: LocaleModule, lang: 'en' | 'zh-cn') {
  return Object.keys(modules).reduce(
    (acc, path) => {
      const moduleName = path.replace(`./${lang}/`, '').replace('.json', '');
      acc[moduleName] = modules[path].default;
      return acc;
    },
    {} as Record<string, Record<string, unknown>>,
  );
}

const cnModules = import.meta.glob('./zh-cn/*.json', { eager: true }) as LocaleModule;
const enModules = import.meta.glob('./en/*.json', { eager: true }) as LocaleModule;
export const znTranslations = createTranslations(cnModules, 'zh-cn');
export const enTranslations = createTranslations(enModules, 'en');
